/* tslint:disable */
/* eslint-disable */
/**
 * Limber Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PhysicianToRegister
 */
export interface PhysicianToRegister {
    /**
     * 
     * @type {number}
     * @memberof PhysicianToRegister
     */
    organizationId: number;
    /**
     * 
     * @type {string}
     * @memberof PhysicianToRegister
     */
    email: string;
}

export function PhysicianToRegisterFromJSON(json: any): PhysicianToRegister {
    return PhysicianToRegisterFromJSONTyped(json, false);
}

export function PhysicianToRegisterFromJSONTyped(json: any, ignoreDiscriminator: boolean): PhysicianToRegister {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'organizationId': json['organization-id'],
        'email': json['email'],
    };
}

export function PhysicianToRegisterToJSON(value?: PhysicianToRegister | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'organization-id': value.organizationId,
        'email': value.email,
    };
}


